export default __webpack_public_path__ + "atomic/_patterns/02-molecules/timeline-item/_timeline-item.twig";